import type { RealEstateCatalogResponseT } from '@/forApp/types/Entity';
import fetcher from '@/forApp/utils/fetcher/fetcher';

export const getEstateCatalog = async (
  type: string,
  searchParams?: { [key: string]: string | string[] },
): Promise<RealEstateCatalogResponseT> => {
  try {
    const queryParams = new URLSearchParams();
    if (searchParams) {
      Object.entries(searchParams).forEach(([key, value]) => {
        if (Array.isArray(value)) {
          value.forEach((v) => queryParams.append(key, v));
        } else {
          queryParams.append(key, value);
        }
      });
    }

    const queryString = queryParams.toString();

    const estateCatalog = await fetcher<RealEstateCatalogResponseT>(
      'GET',
      `/entity-types/${type}${queryString ? `?${queryString}` : ''}`,
    );

    return estateCatalog.data;
  } catch {
    return {
      entities: {
        data: [],
        meta: {
          current_page: 0,
          from: 0,
          last_page: 0,
          links: [],
          path: '',
          per_page: 0,
          to: 0,
          total: 0,
        },
        links: {
          first: '',
          last: '',
          prev: null,
          next: null,
        },
      },
      active: 0,
      entities_count: 0,
      meta_description: '',
      meta_title: '',
      name: '',
      seo_scripts: null,
      slug: '',
      sort: 0,
    };
  }
};
